import { postJson } from '../../util/fetch-json.js';
import type { Slot } from '../../types/manifest.js';
import type { ImageProvider } from '../provider.js';

export const serverImage: ImageProvider = {
  generate: ({ prospect, slot, prompt, styleType, aspectRatio, transparent, seed, companyPrompt, companyName }) => {
    const body: {
      key: string; slot: Slot; prompt: string;
      styleType?: 'GENERAL' | 'DESIGN';
      aspectRatio?: '1x1' | '16x9' | '9x16';
      transparent?: boolean;
      seed?: number;
      companyPrompt?: string;
      companyName?: string;
    } = { key: prospect, slot, prompt };
    if (styleType !== undefined) body.styleType = styleType;
    if (aspectRatio !== undefined) body.aspectRatio = aspectRatio;
    if (transparent !== undefined) body.transparent = transparent;
    if (seed !== undefined) body.seed = seed;
    if (companyPrompt !== undefined) body.companyPrompt = companyPrompt;
    if (companyName !== undefined) body.companyName = companyName;
    return postJson<{ assetKey: string }>('/api/image', body);
  },
  uploadLogo: async (prospect, fileBase64, mime) => {
    const r = await postJson<{ assetKey: string }>('/api/logo-upload', { key: prospect, fileBase64, mime });
    return r;
  },
};
